import { NgModule } from 'ng-metadata/core';
import { PaginationComponent } from './pagination/pagination.component';
import 'angular-material-data-table/dist/md-data-table.js';
import 'angular-material-data-table/dist/md-data-table.css';
import './table.scss';

/**
 * @ngdoc module
 * @name mw.components.table
 * @description
 *
 * Table
 */
@NgModule({
    declarations: [PaginationComponent]
})
export class TableModule {}



// WEBPACK FOOTER //
// ./src/lib/components/table/table.module.ts